import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-sponsor',
  templateUrl: './section-sponsor.component.html',
  styleUrls: ['./section-sponsor.component.scss']
})
export class SectionSponsorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  sponsor=[
    {
      img: 'assets/images/event/sponsor/1.png'
    },
    {
      img: 'assets/images/event/sponsor/2.png'
    },
    {
      img: 'assets/images/event/sponsor/3.png'
    },
    {
      img: 'assets/images/event/sponsor/4.png'
    },
    {
      img: 'assets/images/event/sponsor/5.png'
    },
    {
      img: 'assets/images/event/sponsor/6.png'
    },
    {
      img: 'assets/images/event/sponsor/7.png'
    },
    {
      img: 'assets/images/event/sponsor/8.png'
    }
]

}
